import api from '../../api/api'

// initial state
const state = {
	all: null,
  status: {
    getAvailability: null
  }
}

// getters
const getters = {}

// actions
const actions = {
  getAvailability ({ commit, state }, params) {
    commit('setStatus', { getAvailability: api.status.PENDING })
    return api.getAvailability(params).then((response) => {
      commit('setAvailability', response.data)
      commit('setStatus', { getAvailability: api.status.SUCCESS })
    }).catch((error) => {
      commit('setStatus', { getAvailability: api.status.FAILURE })
    })
  }
}

// mutations
const mutations = {
  setAvailability (state, availability) {
    state.all = availability;
  },
  setStatus (state, status) {
    Object.assign(state.status, status)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
